const SET_MEETINGS_SYMPOSIA_LIST = 'SET_MEETINGS_SYMPOSIA_LIST';

export default {
    SET_MEETINGS_SYMPOSIA_LIST
}